import { useMutation } from '@apollo/client/react'
import React from 'react'
import { useIntl } from 'react-intl'

import { JobItemDiscountType } from '../../common/types'
import { Loading } from '../../components/responses'
import { setErrorNotifications, setFatalErrorNotification } from '../../components/responses/setErrorNotifications'
import { NumberInput, SelectInput, TextInput } from '../layout/form/input'
import { Delete } from './Delete'
import { DELETE_JOB_ITEM } from './queries'
import { DiscountItemRow, ItemColumn } from './styled'
import { DeleteTowingRecordJobItemResponse, JobItemInput } from './types'
import { messages } from './messages'
import { formatMessageSafe } from '../../util/translateInputOptions'

interface Props {
  jobItem: JobItemInput
  index?: number
  removeItem: () => void
  itemsIncludeVat: boolean
  towingRecordId?: number
  disabled?: boolean
}

export const DiscountItem: React.FC<Props> = ({ jobItem, removeItem, towingRecordId, disabled = false }) => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  const discountTypeOptions = [
    { value: JobItemDiscountType.amount, label: formatMessage(messages.discountTypeAmount) },
    { value: JobItemDiscountType.percentage, label: formatMessage(messages.discountTypePercentage) },
  ]

  const [deleteJobItem, { loading }] = useMutation<DeleteTowingRecordJobItemResponse>(DELETE_JOB_ITEM, {
    onCompleted({ deleteTowingRecordJobItem }) {
      if (deleteTowingRecordJobItem.__typename === 'DeleteTowingRecordJobItemSuccess') {
        removeItem()
      } else {
        setErrorNotifications({ data: deleteTowingRecordJobItem })
      }
    },
    onError(err) {
      setFatalErrorNotification(err)
    },
  })

  const deleteNewJobItem = () => {
    removeItem()
  }
  const deleteExistingJobItem = () => {
    deleteJobItem({ variables: { input: { towingRecordId, jobItemId: jobItem.id } } })
  }

  return (
    <DiscountItemRow>
      <Loading loading={loading} />
      <ItemColumn>
        <TextInput label={formatMessage(messages.discount)} name={`discountItem.name`} disabled />
      </ItemColumn>
      <ItemColumn>
        <NumberInput label={formatMessage(messages.quantity)} name={`discountItem.unitPrice`} disabled={disabled}/>
      </ItemColumn>
      <ItemColumn>
        <SelectInput
          label={formatMessage(messages.discountType)}
          name={`discountItem.discountType`}
          options={discountTypeOptions}
          searchable={false}
          disabled={disabled}
        />
      </ItemColumn>
      <ItemColumn />
      <ItemColumn>
        <Delete onClick={jobItem.id && towingRecordId ? deleteExistingJobItem : deleteNewJobItem} disabled={disabled} />
      </ItemColumn>
    </DiscountItemRow>
  )
}
